<template>
  <div>
    <el-row class="cs-contentContainer">
      <el-col :span="4" class="cs-main-left-container">
        <navigator></navigator>
      </el-col>
      <el-col :span="20" class="backgroud-gray cs-fullHeight cs-main-right-container">
        <div class="cs-fullHeight cs-contentContainer-right">
          <div class="backgroud-white cs-contentContainer-right-content cs-fullHeight" v-loading="loading">

            <el-row>
              <el-col>
                <el-steps :active="activeStep" process-status="finish" finish-status="success" simple>
                  <el-step title="学生信息" :status="getStepStatus(0)" @click.native="onStepItemClick(0)"></el-step>
                  <el-step title="选择课程" :status="getStepStatus(1)" @click.native="onStepItemClick(1)"></el-step>
                  <el-step title="缴付款项" :status="getStepStatus(2)" @click.native="onStepItemClick(2)"></el-step>
                  <el-step title="报名成功" :status="getStepStatus(3)" @click.native="onStepItemClick(3)"></el-step>
                </el-steps>
              </el-col>
            </el-row>
            <hr>
            <el-row>
              <el-col :span="8">
                <label>在校课程:{{studentSuggestionData.StudentCourseNames}}</label>
              </el-col>
              <el-col :span="8">
                <label>速成报课:{{studentSuggestionData.SpeedupCourseNames}}</label>
              </el-col>
              <el-col :span="8">
                <label>推荐课程:{{studentSuggestionData.CourseSuggestionNames}}</label>
              </el-col>
            </el-row>
            <el-row class="grid-content">
              <el-col>
                <workflowStep1 ref="workflowStep1" v-show="activeStep===0" :dataIn="step1Model" @reload="onReload" @buyMemberCard="onBuyMemberCard">
                </workflowStep1>
                <workflowStep2 ref="workflowStep2" v-show="activeStep===1" :bonusPointDisabled="bonusPointDisabled" :isCalculating="isCalculating"
                  :dataIn="step2Model" @calculate="onCalculate"></workflowStep2>
                <workflowStep3 ref="workflowStep3" v-show="activeStep===2 || activeStep===3" :bonusPointDisabled="bonusPointDisabled" :dataIn="step3Model"
                  @save="onSaveStep3" @savePaymentStart="onSavePaymentStart" @savePaymentEnd="onSavePaymentEnd" @couponChange="onCouponChange"></workflowStep3>
              </el-col>
            </el-row>
            <el-row class="cs-filter-row">
              <el-col :span="16">
                <el-button v-if="!workflowCompleted && activeStep !==0" size="medium" type="primary" @click="onPreviousStep">上一步
                </el-button>
                <el-button v-if="!workflowCompleted" size="medium" :loading="isCalculating || isSaving"
                  :disabled="submitBtnDisable || isCalculating || isSaving" :type="submitBtnClass" @click="next()">{{submitBtnText}}
                </el-button>
                <el-button v-if="!workflowCompleted && activeStep===2" size="medium" type="danger" @click="onCancelWorkflow">撤销
                </el-button>
                <el-button v-if="activeStep!=0" size="medium" type="danger" @click="onRedoWorkflow">新建流程</el-button>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog :center="true" :close-on-click-modal="false" width="600px" :visible.sync="completedVisible" top="3vh" class="completedMessage">
      <el-row>
        <el-col>
          <img src="../../assets/success.png" />
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <!-- <span>课程报名成功，电子收据已发送至{{dataIn.memberModel.Email}}</span> -->
          <span>课程报名成功</span>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-button type="primary" @click="onCompletedDialogClose">完成</el-button>
        </el-col>
      </el-row>
    </el-dialog>

    <VueDragResize class="cs-workflowDetails-dialog" :x="50" :w="1000" :h="600" :z="999" v-if="workflowDetailsVisible">
      <el-button class="cs-workflowDetails-dialog-close" type="text" @click="onWorkflowDetailsClose"><i class="el-icon-close"></i></el-button>
      <workflowDetails :dataIn="workflowDetailsData"></workflowDetails>
    </VueDragResize>

  </div>
</template>

<style lang="scss" scoped>
.el-col {
  span {
    height: 40px;
    line-height: 40px;
  }
}

.el-button {
  margin-left: 20px;
}
.completedMessage {
  .el-row {
    padding: 30px;

    .el-col {
      text-align: center;
    }
  }
}
.cs-workflowDetails-dialog {
  overflow: visible;
  left: 10%;
  border: 1px solid #ced3d9;
  background-color: white;

  .cs-workflowDetails-dialog-close {
    position: absolute;
    right: 10px;
    font-size: 20px;
    color: black;
  }
}
</style>

<script>
import {
  arrayEquals,
  getCourseTypeText,
  getTax,
  toDecimal,
  getAccountTypeByCourseType,
} from "../../config/mUtils";
import { getGlobalPriceSettings } from "../../service/globalPriceSetting.service";
import { getIntroducers } from "../../service/common.service";
import { getBonusPointMechanismByType } from "../../service/bonusPoint.service";
import {
  createWorkflowModel,
  getActiveWorkflowDataByStudentId,
  calculateEnrollmentFee,
  saveWorkflowData,
  removeWorkflow,
  validateAutonomousPaymentWorkflowCourses,
  getCourseListData,
  getStudentLastRefundWorkflowData,
  getVipCourseAliasList,
} from "../../service/enrollmentFee.service";
import { getStudentSuggestion } from "../../service/student.service";
import { getStudentAdvanceEnrollmentByStudentId } from "../../service/advanceEnrollment.service.js";
import navigator from "../../components/navigator";
import workflowStep1 from "../../components/addCollectFees/courseEnrollmentFee/workflowStep1";
import workflowStep2 from "../../components/addCollectFees/courseEnrollmentFee/workflowStep2";
import workflowStep3 from "../../components/addCollectFees/courseEnrollmentFee/workflowStep3";
import workflowDetails from "../../components/addCollectFees/courseEnrollmentFee/workflowDetails";
import VueDragResize from "vue-drag-resize";
import { mixinCourseDiscount } from "@/components/addCollectFees/courseEnrollmentFee/mixin";

export default {
  mixins: [mixinCourseDiscount],
  inject: ["reload"],
  data() {
    return {
      loading: false,
      isCalculating: false,
      bonusPointDisabled: false,
      activeStep: 0,
      lastStep: 0,
      currentStepCompleted: false,
      submitBtnClass: "info",
      submitBtnDisable: true,
      completedVisible: false,
      priceSettings: {
        memberCardPrice: 0,
        memberCardPriceAfterDiscount: 0,
        adEnrollmentPrice: 0,
        paymentCommissionRate: 0,
        bonusPointToMoney_Money: 0,
        bonusPointToMoney_BonusPoint: 0,
        trainingAdEnrollmentPrice: 0,
      },
      hasBuyMemberCard: false,
      //memberCardDiscountPrice:0,
      memberModel: {},
      workflowOriginalData: {},
      workflowData: {
        CurrentStep: 0,
      },
      step1Model: {
        hasBuyMemberCard: false,
      },
      step2Model: {},
      step3Model: {},
      isSaving: false,
      studentAdvanceEnrollmentList: [],
      studentSuggestionData: {
        SpeedupCourseNames: "",
        StudentCourseNames: "",
        CourseSuggestionNames: "",
      },
      workflowRelatedDicountDetail: "",
      taxModel: {
        hasTaxSetting: false,
        hasTax: true,
        taxRate: 0,
        courseTotalTax: 0,
        isDoubleBonusPoint: false,
      },
      isEditing: false,
      isEditingCompleted: false,
      workflowDetailsVisible: false,
      workflowDetailsData: {},
      introducers: [],
      vipCourseAliasList: [],
    };
  },
  components: {
    navigator,
    workflowStep1,
    workflowStep2,
    workflowStep3,
    workflowDetails,
    VueDragResize,
  },
  computed: {
    submitBtnText: function () {
      let text = "下一步";

      if (this.activeStep === 2 || this.activeStep === 3) {
        text = "完成付款";
      }

      return text;
    },
    workflowCompleted: function () {
      if (this.workflowData) {
        return (
          this.workflowData.IsCompleted ||
          (!this.isEditing &&
            this.workflowData.Status == 1 &&
            this.step3Model &&
            this.step3Model.modelData &&
            this.step3Model.modelData.isAutonomousPayment) ||
          (this.isEditing && this.isEditingCompleted)
        );
      }
      return false;
    },
  },
  created() {
    this.loadIntroducers();
    this.loadPriceSettings();
  },
  mounted() {
    if (!!this.$route.query.studentId) {
      this.$refs["workflowStep1"].searchStudentMemberInfoById(
        this.$route.query.studentId,
        this.$route.query.workflowId,
        !!this.$route.query.initType
      );
    }
  },
  methods: {
    async loadVipCourseAliasList() {
      let studentId = this.memberModel.StudentId;
      try {
        let result = await getVipCourseAliasList(null, studentId);
        this.vipCourseAliasList = !!result && result.success ? result.data : [];
      } catch (error) {
        this.vipCourseAliasList = [];
      }
    },

    async init(workflowId, initType, isRefund) {
      this.isEditingCompleted = false;
      if (workflowId) {
        this.isEditing = true;
      } else {
        this.isEditing = false;
      }
      this.loading = true;
      await this.loadStudentAdvanceEnrollments();
      this.loadStudentSuggestion();
      await this.loadVipCourseAliasList();
      if (isRefund) {
        this.loadWorkflowDetails();
      } else {
        await this.loadWorkflowData(workflowId);
      }
      if (workflowId == 0 && !!initType) {
        this.$nextTick(() => {
          this.next(initType);
        });
      }
    },
    initStepModel() {
      this.workflowOriginalData = JSON.parse(JSON.stringify(this.workflowData));

      if (
        !this.workflowData.IsCompleted &&
        this.workflowData.CurrentStep == 3
      ) {
        this.activeStep = 2;
      } else {
        this.activeStep = this.workflowData.CurrentStep;
      }
      this.taxModel = {
        hasTaxSetting: this.workflowData.HasTaxSetting,
        hasTax: this.workflowData.HasTax,
        courseTotalTax: this.workflowData.CourseTotalTax,
        taxRate: this.workflowData.TaxRate,
        isDoubleBonusPoint: this.workflowData.IsDoubleBonusPoint,
      };

      this.initStep1Model();
      this.initStep2Model();
      this.initStep3Model();
    },
    initStep1Model() {
      let model = { hasBuyMemberCard: false };
      if (!!this.workflowData && this.workflowData.MemberCardPrice > 0) {
        model.hasBuyMemberCard = true;
        this.hasBuyMemberCard = true;
      } else {
        this.hasBuyMemberCard = false;
      }
      this.step1Model = model;
    },
    initStep2Model() {
      let enrollmentCount = 0;
      let trainingEnrollmentCount = 0;
      if (!!this.memberModel) {
        this.bonusPointDisabled = !this.memberModel.IsMember;
        enrollmentCount = this.studentAdvanceEnrollmentList.length;
        trainingEnrollmentCount =
          this.memberModel.TrainingAdvanceEnrollmentCount -
          this.memberModel.TrainingAdvanceEnrollmentCountUsed;
      }
      
      if (!!this.workflowData && this.workflowData.Id > 0) {
        let courseListData = getCourseListData(
          this.workflowData,
          this.memberModel,
          this.studentAdvanceEnrollmentList
        );
        let discountIds = this.workflowData.WorkflowDiscounts.map((i) => {
            return i.FormulaFieldId;
          });
      
        this.step2Model = {
          isCompleted: this.workflowData.IsCompleted,
          courseType: this.workflowData.CourseType,
          hasBuyMemberCard: this.hasBuyMemberCard,
          universityGroupNumber: this.memberModel.UniversityGroupNumber,
          universityGroupText: this.memberModel.UniversityGroupText,
          bonusPoint: this.memberModel.BonusPoint,
          priceSettings: this.priceSettings,
          selectedDiscountList: discountIds,
          courseListData: courseListData,
          studentId: this.memberModel.StudentId,
          workflowId: this.workflowData.Id,
          relatedIdList: this.workflowData.RelatedWorkflowIdList,
          relatedWorkflowType: this.workflowData.RelatedWorkflowType,
          taxModel: this.taxModel,
          vipCourseAliasList: this.vipCourseAliasList,
        };
      } else {
        let courseType = 1;
        if (this.workflowData && this.workflowData.CourseType) {
          courseType = this.workflowData.CourseType;
        }
        this.step2Model = {
          isCompleted: false,
          courseType: courseType,
          hasBuyMemberCard: this.hasBuyMemberCard,
          universityGroupNumber: this.memberModel.UniversityGroupNumber,
          universityGroupText: this.memberModel.UniversityGroupText,
          bonusPoint: this.memberModel.BonusPoint,
          priceSettings: this.priceSettings,
          selectedDiscountList: [],
          courseListData: {
            termId: 0,
            categoryId: 0,
            comment: null,
            enrollmentAvailableCount: enrollmentCount,
            trainingEnrollmentAvailableCount: trainingEnrollmentCount,
            courseList: [],
            studentAdvanceEnrollmentList: this.studentAdvanceEnrollmentList,
            studentAdvanceEnrollmentAdditional: "",
          },
          studentId: this.memberModel.StudentId,
          workflowId: 0,
          relatedIdList: [],
          taxModel: this.taxModel,
          vipCourseAliasList: this.vipCourseAliasList,
        };
      }
    },
    initStep3Model() {
      let enrollmentCountUsed =
        this.step2Model.courseListData.courseList.filter(
          (i) => i.modelData.isAdvanceEnrollmentPrice
        ).length;
      let memberCardDiscountPrice = this.workflowData.BuyMemberCardPrice;
      let enrollmentCount = 0;
      if (this.workflowData.AdvanceEnrollmentCount > 0) {
        enrollmentCount =
          this.workflowData.AdvanceEnrollmentCount - enrollmentCountUsed;
      }
      if (enrollmentCount < 0) {
        enrollmentCount = 0;
      }
     
      let discountName = "";
      if (this.workflowData.WorkflowDiscounts && this.workflowData.WorkflowDiscounts.length > 0){
        const hasName = this.workflowData.WorkflowDiscounts.every(field => !!field.FormulaFieldLabelName);
        if (hasName){
          let listNames = this.workflowData.WorkflowDiscounts.map(i => i.FormulaFieldLabelName);
          discountName = listNames.join(",");
        }else{
          discountName = this.$refs["workflowStep2"].getAllSelectedDiscountName();
        }
      }
     
      let accountType = getAccountTypeByCourseType(
        this.workflowData.CourseType
      );

      let isAllJoinWeChatGroup =
        this.step2Model.courseListData.courseList.every(function (item, index) {
          return item.modelData.weChatGroupType == 1;
        });

      let model = {
        isCompleted: this.workflowData.IsCompleted,
        discountName: discountName,
        accountType: accountType,
        courseType: this.workflowData.CourseType,
        workflowId: this.workflowData.Id,
        balanceInStore: this.workflowData.BalanceInStore,
        courseDiscountTotalPrice: this.workflowData.CourseDiscountTotalPrice,
        advanceEnrollmentTotalPrice:
          this.workflowData.AdvanceEnrollmentPrice +
          this.workflowData.AdvanceEnrollmentPriceTax,
        advanceEnrollmentTotalPriceTax:
          this.workflowData.AdvanceEnrollmentPriceTax,
        workflowRelatedDicountAmount:
          this.workflowData.WorkflowRelatedDicountAmount,
        workflowRelatedDicountDetail: this.workflowRelatedDicountDetail,
        changeCourseDifferentPriceTotal:
          this.workflowData.ChangeCourseDifferentPriceTotal,
        changeCourseRefundPriceTotal:
          this.workflowData.ChangeCourseRefundPriceTotal,
        memberModel: this.memberModel,
        enrollmentCountUsed: enrollmentCountUsed,
        priceSettings: this.priceSettings,
        memberCardModel: {
          hasBuyMemberCard: this.hasBuyMemberCard,
          memberCardDiscountPrice: memberCardDiscountPrice,
        },
        modelData: {
          enrollmentCount: enrollmentCount,
          balance: toDecimal(
            this.workflowData.BalanceCost + this.workflowData.BalanceCostTax,
            4
          ),
          balanceTax: this.workflowData.BalanceCostTax,
          bonusPoint: this.workflowData.BonusPointCost,
          cashDecreased: this.workflowData.CashDecreasedAmount,
          couponDiscountDollar: this.workflowData.CouponDiscountDollar,
          studentAdvanceEnrollmentAdditional:
            this.workflowData.StudentAdvanceEnrollmentAdditional,
          comment: this.workflowData.Comment,
          isAutonomousPayment: this.workflowData.IsAutonomousPayment,
          paymentType: this.workflowData.PaymentType,
          qrCodeImage: this.workflowData.QRCodeImage,
          introducerId: this.workflowData.IntroducerId,
        },
        couponData: {
          couponCode: this.workflowData.CouponCode,
          couponDiscountValue: this.workflowData.CouponDiscountValue,
        },
        studentAdvanceEnrollmentList:
          this.step2Model.courseListData.studentAdvanceEnrollmentList,
        courseList: this.step2Model.courseListData.courseList,
        isAllJoinWeChatGroup: isAllJoinWeChatGroup,
        taxModel: this.taxModel,
        introducers: this.introducers,
      };

      this.step3Model = model;
    },
    getDisountListFromStep2() {
      let discountIds = this.$refs["workflowStep2"].getSelectedDiscountIds();
      let list = [];
      if (discountIds.length > 0) {
        discountIds.forEach((element) => {
          let item = {
            FormulaFieldId: element,
          };
          list.push(item);
        });
      }
      return list;
    },
    getCourseListFromStep2() {
      let list = [];
      if (
        !!this.step2Model &&
        !!this.step2Model.courseListData &&
        !!this.step2Model.courseListData.courseList
      ) {
        this.step2Model.courseListData.courseList.forEach((element) => {
          let workflowCourseViewModel = {
            CourseId: element.courseId,
            CourseCategoryId: element.modelData.categoryId,
            CourseCategoryOptionId: element.modelData.categoryOptionId,
            VipCoursePriceId: element.modelData.vipCoursePriceId,
            CourseCount: element.modelData.courseCount,
            CourseMinutes: element.modelData.courseMinutes,
            IsAdvanceEnrollmentPrice:
              element.modelData.isAdvanceEnrollmentPrice,
            IsInternalPrice: element.modelData.isInternalPrice,
            IsOriginalPrice: element.modelData.isOriginalPrice,
            IsFreeTrial: element.modelData.isFreeTrial,
            IsVideoFree: element.modelData.isVideoFree,
            IsAiCourseEnabled: element.modelData.isAiCourseEnabled,
            StartWeek: element.modelData.startWeek,
            SupplementVideoType: element.modelData.supplementVideoType,
            SupplementVideoCount: element.modelData.supplementVideoCount,
            ContractId: element.modelData.contractId,
            WeChatGroupType: element.modelData.weChatGroupType,
            Comment: element.modelData.comment,
            CourseType: element.courseType,
            CampusId: element.campusId,
            SelectedStudentAdvanceEnrollmentId:
              element.modelData.selectedStudentAdvanceEnrollmentId,
            BonusPointCost: element.priceData.bonusPointCost,
            BonusPointAmount: element.priceData.bonusPointAmount,
            CashDecreasedAmount: element.priceData.cashDecreasedAmount,
            YearCourseType: element.modelData.yearCourseType,
            CouponCode: element.priceData.couponCode,
            CouponDiscountDollar: element.priceData.couponDiscountDollar,
            CourseActivationIdList: element.modelData.courseActivationIdList,
            FreeTrialCourseActivationId: element.modelData.freeTrialCourseActivationId,
            CourseAlias: element.modelData.courseAlias,
            ReviewCourseStartValue: element.modelData.reviewCourseStart,
            ReviewCourseEndValue: element.modelData.reviewCourseEnd,
          };
          list.push(workflowCourseViewModel);
        });
      }
      return list;
    },
    calculatePrice() {
      this.setValueForWorkflowModel();
      if (this.workflowData.WorkflowCourses.length == 0) {
        return;
      }
      this.isCalculating = true;
      calculateEnrollmentFee(this.workflowData)
        .then((result) => {
          if (result && result.success) {
            //this.calculateResult = result.data;
            let isSuccess = this.setCalculationPrice(result.data);
            if (isSuccess) {
              this.submitBtnDisable = false;
              this.submitBtnClass = "primary";
            } else {
              this.submitBtnDisable = true;
              this.submitBtnClass = "info";
            }
          }
          this.isCalculating = false;
        })
        .catch(() => {
          this.isCalculating = false;
        });
    },
    getCourseIndex(courseId, result) {
      let pre = "CourseId";
      let courseIdList = result.filter((x) => x.Name.includes(pre));
      let item = courseIdList.find((x) => x.Value == courseId);
      let strIndex = item.Name.substring(pre.length);
      let index = parseInt(strIndex);

      return index;
    },
    setCalculationPrice(result) {
      let isSuccess = true;

      this.workflowData.BuyMemberCardPrice = this.getVariableResultValue(
        result,
        "MembershipCardDiscountPrice"
      );

      if (!!this.step2Model && !!this.step2Model.courseListData) {
        let courseCount = this.step2Model.courseListData.courseList.length;
        for (let i = 0; i < courseCount; i++) {
          let item = this.step2Model.courseListData.courseList[i];
          let index = this.getCourseIndex(item.courseId, result);
          this.$set(
            item.priceData,
            "price",
            this.getVariableResultValue(result, "CoursePrice" + index)
          );
          this.$set(
            item.priceData,
            "weekPrice",
            this.getVariableResultValue(result, "CourseWeekPrice" + index)
          );
          this.$set(
            item.priceData,
            "discountPrice",
            this.getVariableResultValue(result, "CourseDiscountPrice" + index)
          );
          this.$set(
            item.priceData,
            "couponDiscountPrice",
            this.getVariableResultValue(
              result,
              "CourseCouponDiscountPrice" + index
            )
          );
          let subtotal = this.getVariableResultValue(
            result,
            "CoursePriceSubtotal" + index
          );
          if (item.priceData.bonusPointAmount > 0)
            subtotal -= item.priceData.bonusPointAmount;
          if (item.priceData.cashDecreasedAmount > 0)
            subtotal -= item.priceData.cashDecreasedAmount;
          if (item.priceData.couponDiscountDollar > 0)
            subtotal -= item.priceData.couponDiscountDollar;
          this.$set(item.priceData, "subtotal", subtotal);
          if (subtotal < 0) isSuccess = false;
          this.$set(
            item.priceData,
            "supplementVideoPrice",
            this.getVariableResultValue(
              result,
              "CoursSupplementVideoPrice" + index
            )
          );

          index++;
        }

        let courseListData = this.step2Model.courseListData;
        this.$set(
          courseListData,
          "bonusPoint",
          this.step3Model.modelData.bonusPoint
        );
        this.$set(
          courseListData,
          "cashDecreased",
          this.step3Model.modelData.cashDecreased
        );

        let courseList = courseListData.courseList;
        let courseDiscountTotalPrice = courseList.sum(
          (course) => course.priceData.discountPrice
        );
        let bonusPoint = courseListData.bonusPoint;
        let cashDecreased = courseListData.cashDecreased;
        this.__reallocateCourseDiscount(
          this.priceSettings,
          courseList,
          bonusPoint,
          cashDecreased
        );

        let allBonusPointCost = courseList.sum(
          (course) => course.priceData.bonusPointCost
        );
        let allCashDecreasedAmount = courseList.sum(
          (course) => course.priceData.cashDecreasedAmount
        );
        let allCouponDiscountDollar = courseList.sum(
          (course) => course.priceData.couponDiscountDollar
        );

        this.$set(this.step3Model.modelData, "bonusPoint", allBonusPointCost);
        this.$set(
          this.step3Model.modelData,
          "cashDecreased",
          allCashDecreasedAmount
        );
        this.$set(
          this.step3Model.modelData,
          "couponDiscountDollar",
          allCouponDiscountDollar
        );
      }

      if (!!this.step3Model) {
        let advanceEnrollmentTotalPrice = this.getVariableResultValue(
          result,
          "AdvanceEnrollmentTotalPrice"
        );
        let advanceEnrollmentTotalPriceTax = 0;
        if (this.taxModel.hasTax) {
          advanceEnrollmentTotalPriceTax =
            advanceEnrollmentTotalPrice * this.taxModel.taxRate;
          advanceEnrollmentTotalPrice += advanceEnrollmentTotalPriceTax;
        }

        this.$set(
          this.step3Model,
          "advanceEnrollmentTotalPrice",
          advanceEnrollmentTotalPrice
        );
        this.$set(
          this.step3Model,
          "advanceEnrollmentTotalPriceTax",
          advanceEnrollmentTotalPriceTax
        );
        this.setAdvanceEnrollmentTotalPriceForWorkflowModel();

        this.$set(
          this.step3Model,
          "courseDiscountTotalPrice",
          this.getVariableResultValue(result, "CourseDiscountTotalPrice")
        );
        this.$set(
          this.step3Model,
          "workflowRelatedDicountAmount",
          this.getVariableResultValue(result, "WorkflowRelatedDicountAmount")
        );

        let workflowRelatedDicountDetailVariable = this.getVariableResult(
          result,
          "WorkflowRelatedDicountDetail"
        );
        if (!!workflowRelatedDicountDetailVariable) {
          this.$set(
            this.step3Model,
            "workflowRelatedDicountDetail",
            workflowRelatedDicountDetailVariable.Description
          );
          this.workflowRelatedDicountDetail =
            workflowRelatedDicountDetailVariable.Description;
        } else {
          this.workflowRelatedDicountDetail = "";
        }

        if (
          !this.workflowData.Id &&
          this.step3Model.courseDiscountTotalPrice === 0
        ) {
          this.step3Model.modelData.isAutonomousPayment = false;
        }
      }
      if (!!this.step3Model && !!this.step3Model.memberCardModel) {
        this.$set(
          this.step3Model.memberCardModel,
          "hasBuyMemberCard",
          this.hasBuyMemberCard
        );
        this.$set(
          this.step3Model.memberCardModel,
          "memberCardDiscountPrice",
          this.workflowData.BuyMemberCardPrice
        );
        this.$refs["workflowStep3"].loadWorkflowInfoData();
      }

      return isSuccess;
    },
    getVariableResultValue(result, name) {
      let item = this.getVariableResult(result, name);
      if (!!item) {
        return item.Value;
      }
      return 0;
    },
    getVariableResult(result, name) {
      let item = result.filter((i) => i.Name == name);
      if (item && item.length) {
        return item[0];
      }
      return null;
    },
    setAdvanceEnrollmentTotalPriceForWorkflowModel() {
      this.workflowData.AdvanceEnrollmentPrice =
        this.step3Model.advanceEnrollmentTotalPrice -
        this.step3Model.advanceEnrollmentTotalPriceTax;
      this.workflowData.AdvanceEnrollmentPriceTax =
        this.step3Model.advanceEnrollmentTotalPriceTax;
    },
    setValueForWorkflowModel() {
      if (this.hasBuyMemberCard) {
        this.workflowData.MemberCardPrice =
          this.priceSettings.memberCardPriceAfterDiscount;
      } else {
        this.workflowData.MemberCardPrice = 0;
      }

      this.workflowData.HasTax = this.taxModel.hasTax;
      this.workflowData.CourseTotalTax = this.taxModel.courseTotalTax;
      this.workflowData.TaxRate = this.taxModel.taxRate;
      this.workflowData.IsDoubleBonusPoint = this.taxModel.isDoubleBonusPoint;

      let enrollmentCountUsed =
        this.step2Model.courseListData.courseList.filter(
          (i) => i.modelData.isAdvanceEnrollmentPrice
        ).length;
      this.workflowData.AdvanceEnrollmentCount =
        enrollmentCountUsed +
        parseInt(this.step3Model.modelData.enrollmentCount);

      this.workflowData.BalanceCost = toDecimal(
        this.step3Model.modelData.balance -
          this.step3Model.modelData.balanceTax,
        4
      );
      this.workflowData.BalanceCostTax = this.step3Model.modelData.balanceTax;
      this.workflowData.BonusPointCost = this.step3Model.modelData.bonusPoint;
      this.workflowData.CashDecreasedAmount =
        this.step3Model.modelData.cashDecreased;
      this.workflowData.CouponDiscountDollar =
        this.step3Model.modelData.couponDiscountDollar;
      this.workflowData.Comment = this.step3Model.modelData.comment;
      this.workflowData.CourseDiscountTotalPrice =
        this.step3Model.courseDiscountTotalPrice;
      this.workflowData.IsAutonomousPayment =
        this.step3Model.modelData.isAutonomousPayment;
      this.workflowData.PaymentType = this.step3Model.modelData.paymentType;
      this.workflowData.QRCodeImage = this.step3Model.modelData.qrCodeImage;
      this.workflowData.IntroducerId = this.step3Model.modelData.introducerId;

      this.workflowData.WorkflowRelatedDicountAmount =
        this.step3Model.workflowRelatedDicountAmount;
      this.workflowData.StudentAdvanceEnrollmentAdditional =
        this.step3Model.modelData.studentAdvanceEnrollmentAdditional;

      this.workflowData.CouponCode = this.step3Model.couponData.couponCode;
      this.workflowData.CouponDiscountValue =
        this.step3Model.couponData.couponDiscountValue;
      if (!this.workflowData.CouponCode) {
        this.workflowData.CouponDiscountValue = null;
      }

      this.workflowData.WorkflowDiscounts = this.getDisountListFromStep2();
      this.workflowData.WorkflowCourses = this.getCourseListFromStep2();
      if (this.step2Model.courseListData.courseList.length > 0)
        this.workflowData.CourseType =
          this.step2Model.courseListData.courseList[0].courseType;
      else this.workflowData.CourseType = this.step2Model.courseType;
      this.workflowData.RelatedWorkflowIdList =
        this.$refs["workflowStep2"].getSelectedWorkflow();
      this.workflowData.RelatedWorkflowType =
        this.$refs["workflowStep2"].getRelatedWorkflowType();
      //let discountName = this.$refs["workflowStep2"].getSelectedDiscountName();
    },
    onBuyMemberCard(data) {
      this.hasBuyMemberCard = data.isBuy;
      this.$set(this.step2Model, "hasBuyMemberCard", this.hasBuyMemberCard);
      this.calculatePrice();
    },
    onReload(data, workflowId, initType, isRefund) {
      if (!!data.memberModel && !!data.memberModel.StudentId) {
        if (isRefund) {
          this.submitBtnDisable = true;
          this.submitBtnClass = "info";
        } else {
          this.submitBtnDisable = false;
          this.submitBtnClass = "primary";
        }

        this.memberModel = data.memberModel;
        this.hasBuyMemberCard = data.hasBuyMemberCard;
      } else {
        this.submitBtnDisable = true;
        this.submitBtnClass = "info";
        this.memberModel = {};
        this.hasBuyMemberCard = false;
      }
      this.init(workflowId, initType, isRefund);
    },
    loadWorkflowDetails() {
      this.loading = true;
      getStudentLastRefundWorkflowData(this.memberModel.StudentId)
        .then((result) => {
          if (result && result.success) {
            if (result.data) {
              this.workflowDetailsVisible = true;
              this.workflowDetailsData = {
                priceSettings: this.priceSettings,
                memberModel: this.memberModel,
                studentAdvanceEnrollmentList: this.studentAdvanceEnrollmentList,
                workflowData: result.data,
              };
            } else {
              this.$message.warning("未查询到该学生本学期退课记录");
            }
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    onCalculate() {
      this.calculatePrice();
    },
    getStepStatus(step) {
      let stepStatus = "finish";

      if (step != this.activeStep) {
        stepStatus = "process";
        if (step < this.workflowData.CurrentStep) {
          stepStatus = "success";
        } else if (step > this.workflowData.CurrentStep) {
          stepStatus = "wait";
        } else if (this.workflowData.CurrentStep === 3 && step === 3) {
          stepStatus = "success";
        }
      }

      return stepStatus;
    },
    onStepItemClick(step) {
      if (step === this.activeStep || step > this.workflowData.CurrentStep)
        return;

      this.activeStep = step;
    },
    async next(initType) {
      let isSuccess = true;
      if (this.activeStep >= 1) {
        isSuccess = await this.saveCurrentStep(true);
      }
      if (isSuccess) {
        this.activeStep++;
        switch (this.activeStep) {
          case 1:
            if (initType == 1) {
              this.$nextTick(() => {
                this.$refs["workflowStep2"].initCourseListForEnrollFreeTrial(
                  this.memberModel.StudentId
                );
              });
            }
            break;
          case 2:
            this.initStep3Model();
            break;
        }
      }
    },
    validSave(isCompleted) {
      let isValid = true;
      let message = "";
      if (this.workflowData.EnrollmentType == 2) {
        if (this.workflowData.WorkflowCourses.length == 0) {
          isValid = false;
          message += "未选择任何课程<br />";
        } else {
          if (this.workflowData.CourseType == 1) {
            let notSelected = this.workflowData.WorkflowCourses.filter(
              (i) =>
                !!i.IsAdvanceEnrollmentPrice &&
                !i.SelectedStudentAdvanceEnrollmentId
            );
            this.workflowData.WorkflowCourses.forEach((course) => {
              if (!!course.IsVideoFree && course.Comment.length === 0) {
                isValid = false;
                message += "选择视频课请添加备注<br />";
              }
            });
            if (notSelected.length > 0) {
              isValid = false;
              message += "请选择占位<br />";
            }
          }

          if (isCompleted) {
            if (this.activeStep == 2) {
              isValid =
                this.$refs["workflowStep3"].checkUseBalanceEditorSaved();
              if (!isValid) {
                message += "请先保存现金减/积分<br />";
              }

              isValid = this.$refs["workflowStep3"].checkCompleteAvailable();
              if (!isValid) {
                message += "至少要付款20%才能完成课程报名<br />";
              }

              if (this.step3Model.modelData.isAutonomousPayment) {
                let accountAmount =
                  this.$refs["workflowStep3"].getAccountAmount();
                if (accountAmount == 0) {
                  isValid = false;
                  message +=
                    "应付价格为0，请选择收费方式为 前台收费 后，完成课程报名<br />";
                }
              }
            }
          }
        }

        for (
          let i = 0;
          i < this.step2Model.courseListData.courseList.length;
          i++
        ) {
          let item = this.step2Model.courseListData.courseList[i];
          if (
            !!item.priceData.couponCode &&
            !item.priceData.couponDiscountDollar
          ) {
            message += `优惠码 ${item.priceData.couponCode} 需要进行验证，如验证未通过，请删除优惠码<br />`;
            isValid = false;
          } else if (
            !item.priceData.couponCode &&
            !!item.priceData.couponDiscountDollar
          ) {
            message += `课程 ${item.courseName} 使用了优惠劵,但是没有优惠码<br />`;
            isValid = false;
          }

          if (
            item.modelData.categoryId ===
              this.GLOBAL.enumNormalCourseCategory.Vip &&
            !item.modelData.courseAlias
          ) {
            isValid = false;
            message += `请输入课程${item.courseName}备注名<br />`;
          }
        }
      }
      if (!!message) {
        this.$message({
          dangerouslyUseHTMLString: true,
          message: message,
          type: "warning",
        });
      }
      return !message;
    },
    onSaveStep3() {
      this.calculatePrice();
      let isSuccess = this.saveCurrentStep(false);
      if (isSuccess) {
        this.step2Model.courseListData.comment =
          this.step3Model.modelData.comment;
        this.step2Model.courseListData.studentAdvanceEnrollmentAdditional =
          this.step3Model.modelData.studentAdvanceEnrollmentAdditional;
      }
    },
    async saveCurrentStep(isCompleted) {
      if (this.workflowData.IsCompleted) return true;

      if (!this.validSave(isCompleted)) {
        return false;
      }

      let isSave = true;
      switch (this.activeStep) {
        case 0:
          break;
        case 1:
          break;
        case 2:
        case 3:
          if (isCompleted) {
            isSave = await this.$confirm("是否要完成该流程?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(() => {
                return true;
              })
              .catch(() => {
                return false;
              });
            if (isSave) {
              if (
                this.step3Model &&
                this.step3Model.modelData &&
                this.step3Model.modelData.isAutonomousPayment
              ) {
                if (!this.workflowData.Status) {
                  this.workflowData.Status = 1;
                }
                this.isEditingCompleted = true;
              } else {
                this.workflowData.IsCompleted = true;
              }
            }
          }
          break;
      }

      if (!isSave) {
        return;
      }

      let isSuccess = true;
      this.loading = true;
      this.setValueForWorkflowModel();
      if (this.activeStep == 1) {
        let courseIds = this.workflowData.WorkflowCourses.map(
          (i) => i.CourseId
        );
        validateAutonomousPaymentWorkflowCourses(
          this.memberModel.StudentId,
          this.workflowData.Id,
          courseIds
        ).then((result) => {
          if (result && !result.success && result.message) {
            this.$alert(result.message, {
              type: "warning",
            });
          }
        });
      }
      if (isCompleted) {
        let step = this.activeStep + 1;
        if (step > 3) {
          step = 3;
        }

        if (this.workflowData.CurrentStep < step) {
          this.workflowData.CurrentStep = step;
        }
      }
      this.isSaving = true;
      let result = await saveWorkflowData(this.workflowData);

      this.isSaving = false;
      if (result && result.success) {
        this.workflowData.Id = result.data.Id;
        this.workflowData.QRCodeImage = result.data.QRCodeImage;

        this.step2Model.isCompleted = this.workflowCompleted;
        this.step3Model.isCompleted = this.workflowCompleted;
        this.step3Model.modelData.qrCodeImage = this.workflowData.QRCodeImage;
        this.workflowOriginalData = JSON.parse(
          JSON.stringify(this.workflowData)
        );

        if (this.workflowCompleted) {
          this.step2Model.relatedIdList =
            this.workflowData.RelatedWorkflowIdList;
          this.showCompletedDialog();
          this.loadStudentSuggestion();
          let member = await this.$refs["workflowStep1"].loadMemberInfo(false);
          this.memberModel = member;

          if (!!this.step3Model) {
            this.$set(this.step3Model, "memberModel", member);
          }
        }
      } else {
        this.workflowData.IsCompleted = false;
        this.workflowData.Status = 0;
        this.$message({
          message: result.message,
          type: "error",
        });
        isSuccess = false;
      }
      this.loading = false;

      return isSuccess;
    },
    loadPriceSettings() {
      getBonusPointMechanismByType(2).then((result) => {
        if (result && result.success) {
          this.priceSettings.bonusPointToMoney_Money = result.data.Money;
          this.priceSettings.bonusPointToMoney_BonusPoint =
            result.data.BonusPoint;
        }
      });
      getGlobalPriceSettings().then((result) => {
        if (!!result && result.success) {
          this.priceSettings.memberCardPrice = this.findPriceByType(
            result.data,
            4
          );
          this.priceSettings.adEnrollmentPrice = this.findPriceByType(
            result.data,
            6
          );
          this.priceSettings.paymentCommissionRate = this.findPriceByType(
            result.data,
            5
          );
          this.priceSettings.trainingAdEnrollmentPrice = this.findPriceByType(
            result.data,
            10
          );
          this.priceSettings.memberCardPriceAfterDiscount =
            this.findPriceByType(result.data, 12);
        }
      });
    },
    loadIntroducers() {
      getIntroducers().then((result) => {
        if (!!result && result.success) {
          this.introducers = result.data;
          if (this.step3Model) {
            this.step3Model.introducers = this.introducers;
          }
        }
      });
    },
    findPriceByType(gpSettings, type) {
      let result = null;

      for (let i = 0; i < gpSettings.length; i++) {
        let gpSetting = gpSettings[i];
        if (gpSetting.Type === type) {
          result = gpSetting;
          break;
        }
      }

      return result != null ? result.Value : 0;
    },
    async loadWorkflowData(workflowId) {
      let studentId = this.memberModel.StudentId;

      if (!studentId) {
        this.workflowData = createWorkflowModel(2);
        this.loading = false;
      } else {
        this.loading = true;

        try {
          let result = await getActiveWorkflowDataByStudentId(
            studentId,
            2,
            false,
            workflowId
          );
          if (!!result && result.success) {
            this.workflowData = result.data;
            this.workflowData.EnrollmentType = 2;

            this.initStepModel();
          } else {
            this.workflowData = createWorkflowModel(2);
            this.initStepModel();
          }
        } catch (error) {
        } finally {
          this.loading = false;
        }
      }
    },
    showCompletedDialog() {
      this.completedVisible = true;
    },
    onCompletedDialogClose() {
      this.completedVisible = false;
    },
    redoCurrentWorkFlow() {
      if (!!this.workflowData.Id && !this.workflowCompleted) {
        this.removeCurrentWorkFlow(true, () => {
          this.reloadPage();
        });
      } else {
        this.reloadPage();
      }
    },
    reloadPage() {
      this.reload();
    },
    removeCurrentWorkFlow(forceCancel, callback) {
      var a = this.workflowData;
      if (this.activeStep == 1 && !forceCancel) {
        this.activeStep = 0;
        this.$refs["workflowStep1"].searchStudentMemberInfoByPhone();
        return;
      }
      if (!!this.workflowData && !!this.workflowData.Id) {
        this.loading = true;
        removeWorkflow(this.workflowData.Id).then((result) => {
          if (!!result && result.success) {
            this.$message({
              message: "撤销流程成功",
              type: "success",
            });
            this.activeStep = 0;
            this.$refs["workflowStep1"].searchStudentMemberInfoByPhone();
            if (callback) {
              callback();
            }
            //this.init();
          } else {
            this.$message({
              message: result.message,
              type: "error",
            });
          }
          this.loading = false;
        });
      }
    },
    onRedoWorkflow() {
      if (this.workflowCompleted) {
        this.redoCurrentWorkFlow();
      } else {
        let msg = "新建流程将撤销当前流程，是否继续?";
        this.$confirm(msg, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.redoCurrentWorkFlow();
          })
          .catch(() => {});
      }
    },
    onPreviousStep() {
      this.onStepItemClick(this.activeStep - 1);
    },
    onCancelWorkflow() {
      this.$confirm("是否撤销该流程?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.removeCurrentWorkFlow();
        })
        .catch(() => {});
    },
    async loadStudentAdvanceEnrollments() {
      await getStudentAdvanceEnrollmentByStudentId(
        this.memberModel.StudentId
      ).then((result) => {
        if (!!result && result.success) {
          this.studentAdvanceEnrollmentList = result.data;
        }
      });
    },
    loadStudentSuggestion() {
      this.studentSuggestionData.SpeedupCourseNames = "";
      this.studentSuggestionData.StudentCourseNames = "";
      this.studentSuggestionData.CourseSuggestionNames = "";
      if (!!this.memberModel && !!this.memberModel.StudentId) {
        getStudentSuggestion(this.memberModel.StudentId).then((result) => {
          if (!!result && result.success) {
            this.studentSuggestionData = result.data;
          }
        });
      }
    },
    onSavePaymentStart() {
      this.isSaving = true;
    },
    onSavePaymentEnd() {
      this.isSaving = false;
    },
    onWorkflowDetailsClose() {
      this.workflowDetailsVisible = false;
    },
    onCouponChange(couponModel) {
      this.calculatePrice();
    },
    //removeUsedStudentAdvanceEnrollment(saeList) {

    //  if (!!this.step2Model.courseListData.courseList) {

    //    saeList.foreach(sae => {
    //        this.step2Model.courseListData.courseList.forEach(element => {

    //          if (element.modelData.SelectedStudentAdvanceEnrollmentId == sae.Id) {
    //            sae.Used = true;
    //          }
    //        });
    //    });

    //  }
    //}
  },
  watch: {
    $route(to, from) {
      // 刷新参数放到这里里面去触发就可以刷新相同界面了
      if (!!this.$route.query.studentId) {
        this.$refs["workflowStep1"].searchStudentMemberInfoById(
          this.$route.query.studentId,
          this.$route.query.workflowId,
          !!this.$route.query.initType
        );
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/page/addCollectFees/courseEnrollmentFee.vue